import getInstance from './instance';

export default class RecurrenceApi {
  static async getRecurrence () {
    const instance = await getInstance();
    const { data } = await instance.get('/recurrence/mine');
    return data;
  }
}